import React from 'react';

const Dota2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1690_72613)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.3425 0.399507H13.5193L12.7598 0.779216L12.0004 0.399507H8.42647L7.56558 0.830181H5.18631L4.32542 0.399507H0.650002V7.31554L1.08068 8.17643V10.5557L0.650002 11.4166V15.092H7.99625L8.75567 14.7123L9.51509 15.092H15.343V9.26414L14.9633 8.50472L15.343 7.7453V0.399048L15.3425 0.399507ZM4.52423 12.5093L3.23267 11.2178V8.63511L7.1069 12.5093H4.52423ZM12.3296 12.5093H10.6078L9.49213 11.198L9.2621 10.2637L8.37642 9.88719L3.23313 3.84352L4.09402 2.98263L12.7603 9.49646L12.3296 12.5093ZM12.7598 6.8564L8.88561 2.98217H11.4683L12.7598 4.27374V6.8564Z",
      fill: "#B3B3B3"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1690_72613" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "14.6925",
      height: "14.6925",
      fill: "white",
      transform: "translate(0.650002 0.400024)"
    }
  )))
);
Dota2.displayName = "Icons.Dota2";

export { Dota2 };
//# sourceMappingURL=Dota2.js.map
